module.exports = ".error {\n  color: red;\n}\n\n.hot-container {\n  height: 500px;\n  width: 100%;\n  overflow: hidden;\n}\n"